/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {css, StyleSheet} from 'aphrodite';
import $ from 'jquery';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import _ from 'underscore';

import Backdrop from 'components/Backdrop';
import * as browser from 'lib/Browser';
import setTestAttrs from 'test/lib/cypress/setTestAttrs';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import testAttrsAsUnsafeHTML from 'test/lib/cypress/testAttrsAsUnsafeHTML';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as clipboard from 'util/Clipboard';
import {BasicEvent, ElementMouseEvent} from 'util/Types';
import uniqueId from 'util/uniqueId';

export interface ClickableContextMenuOption {
  id?: string;
  name: string;
  click?: ((e?: ElementMouseEvent) => void) | null;
  displayGroup?: ContextMenuDisplayGroup;
  dataTestAttrs?: DataTestAttrs;
  menu?: Array<ContextMenuOption | null> | null;
  hide?: (() => boolean | undefined) | boolean;
  disabled?: (() => boolean) | boolean;
  active?: () => boolean;
  tooltip?: string | null;
  copy?: Function | string;
  close?: Function;
  shortcut?: string;
}

export type ContextMenuOption = ClickableContextMenuOption | '-';

export enum ContextMenuDisplayGroup {
  TOP = 'TOP',
  MIDDLE = 'MIDDLE',
  BOTTOM = 'BOTTOM',
}

const CHEVRON_RIGHT_SVG = ReactDOMServer.renderToStaticMarkup(
  <BenchlingIcon
    icon="chevron-right"
    style={{
      marginLeft: 8,
      flexShrink: 0,
    }}
  />
);

function isString(value: string | Function): value is string {
  return typeof value === 'string';
}

function isFunction(value: string | Function): value is Function {
  return typeof value === 'function';
}

class ContextMenuView extends Backdrop {
  handlers!: {[itemId: string]: ((e: ElementMouseEvent) => void) | undefined | null};
  closehandlers!: {[itemId: string]: Function | undefined};
  menu: Array<ContextMenuOption> | null = null;
  hasRendered!: boolean;
  previousFocusedElement: Element | null = null;
  menuCloseHandler?: () => void;

  static initClass(): void {
    /*
    singleton class that exists for the entire applications
    and renders / manages the context menu
    */
    this.prototype.tagName = 'ul';
    this.prototype.id = 'context-menu';
    this.prototype.className = 'dropdown-menu contextMenu';
  }

  override initialize(): void {
    this.open = this.open.bind(this);
    this.render = this.render.bind(this);
    // oxlint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
    this.hasRendered = false;
    // Set role="menu" immediately so it's available for accessibility queries even when menu is empty
    this.$el.attr('role', 'menu');
    // Similarly, set DTAs immediately so they're available for test queries
    setTestAttrs(this.$el, {component: 'ContextMenu', element: 'root'});
  }

  override events(): Record<string, string> {
    return {
      'click .context-item': 'onClick',
      'contextmenu .context-item': 'onCtxMenu',
    };
  }

  onClick(e: ElementMouseEvent): JQuery | undefined | void {
    if (this.handlers[e.currentTarget.id]) {
      this.handlers[e.currentTarget.id]!.apply(e.currentTarget);
      if (this.closehandlers[e.currentTarget.id] != null) {
        this.closehandlers[e.currentTarget.id]!.apply(e.currentTarget, [this.previousFocusedElement]);
      }
      return this.close();
    }
  }

  onCtxMenu(e: ElementMouseEvent): JQuery | undefined | void {
    this.onClick(e);
    e.preventDefault();
    return this.close();
  }

  // Returns if the menu opened.
  // @ts-expect-error Property 'open' in type 'ContextMenuView' is not assignable to the same property in base type 'Backdrop'
  open(
    e: BasicEvent | Event,
    menu: Array<ContextMenuOption | null>,
    raiseZIndex: boolean = false,
    menuCloseHandler?: () => void
  ): boolean {
    this.previousFocusedElement = document.activeElement;
    if ((e as ElementMouseEvent).altKey && window.debug) {
      e.stopPropagation();
      return false;
    }

    e.preventDefault();
    e.stopPropagation();
    super.open();

    // Synthetic React events need to have persist() called since they're being used async.
    if ((e as ElementMouseEvent).persist) {
      (e as ElementMouseEvent).persist();
    }

    // we want the menu to open after all right click handlers have been called,
    // i.e. updating the selection
    // eslint-disable-next-line no-restricted-syntax
    _.defer(_.bind(this.openDeferred, this), e, menu, raiseZIndex, menuCloseHandler);
    return true;
  }

  openDeferred = (
    e: ElementMouseEvent,
    menu: Array<ContextMenuOption>,
    raiseZIndex: boolean,
    menuCloseHandler?: () => void
  ): void => {
    this.hasRendered = true;
    this.handlers = {};
    this.closehandlers = {};
    this.menuCloseHandler = menuCloseHandler;

    if (menu.some((item) => !_.result(item, 'hide') && item !== '-')) {
      this.menu = menu;

      this.render();

      const x = Math.min(e.pageX, $(window).width() - this.$el.outerWidth());
      const y = Math.min(e.pageY, $(window).height() - this.$el.outerHeight());

      this.$el.css({
        display: 'block',
        left: x,
        top: y,
      });

      if (y > $(window).height() / 2) {
        this.$el.addClass('dropup');
      } else {
        this.$el.removeClass('dropup');
      }

      if (raiseZIndex) {
        this.overlay.addClass('backdrop--raised');
        this.$el.addClass('contextmenu--raised');
      } else {
        this.overlay.removeClass('backdrop--raised');
        this.$el.removeClass('contextmenu--raised');
      }

      if (x > $(window).width() - 3 * this.$el.outerWidth()) {
        this.$el.find('.dropdown-submenu').addClass('submenu-pull-left');
      }

      this.$el.before(this.overlay);
    }
  };

  // @ts-expect-error Property 'close' in type 'ContextMenuView' is not assignable to the same property in base type 'Backdrop'
  close(): JQuery | void {
    if (!this.hasRendered) {
      return;
    }
    super.close();
    this.trigger('close');
    this.$el.hide();
    this.hasRendered = false;
    this.menuCloseHandler?.();
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return this.$('[data-toggle="tooltip"]').tooltip('destroy');
  }

  // @ts-expect-error Property 'remove' in type 'ContextMenuView' is not assignable to the same property in base type 'Backdrop'.
  remove(): JQuery {
    super.remove();
    this.hasRendered = false;
    // @ts-expect-error: this `remove()` method seems typed incorrectly
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return this.$('[data-toggle="tooltip"]').tooltip('destroy');
  }

  _renderMenu(menu: Array<ContextMenuOption>): string {
    let i;
    let item;
    const sections: Array<Array<ContextMenuOption>> = [[]];
    for (item of Array.from(menu)) {
      if (item === '-') {
        sections.push([]);
      } else if (!_(item).result('hide')) {
        const section = sections[sections.length - 1];
        section.push(item);
      }
    }
    menu = _.chain(sections)
      .filter((section) => section.length !== 0)
      // @ts-expect-error Warning: Not all code paths return a value.
      .each((section, i) => {
        if (i !== 0) {
          return section.unshift('-');
        }
      })
      .flatten()
      .value();
    return (() => {
      const result = [];
      for (i = 0; i < menu.length; i++) {
        item = menu[i];
        if (item === '-') {
          result.push("<li class='divider'></li>");
        } else if (item.menu != null) {
          // Submenus are not scrollable if they have their own submenus
          const isScrollable = !_.any(
            item.menu,
            (subMenuItem) => subMenuItem != null && subMenuItem.hasOwnProperty('menu')
          );
          const dropdownMenuClass = isScrollable ? 'dropdown-menu dropdown-menu-scrollable' : 'dropdown-menu';
          const testAttr = item.dataTestAttrs ? testAttrsAsUnsafeHTML(item.dataTestAttrs) : '';
          result.push(`\
<li class='dropdown-submenu' ${testAttr} role='menuitem' aria-label='${_.escape(item.name)}'>
    <a class='context-submenu-item ${css(styles.submenuAnchor)}' aria-hidden='true'>${_.escape(item.name)}${CHEVRON_RIGHT_SVG}</a>
    <ul class='${dropdownMenuClass}' role='menu' aria-label='${_.escape(item.name)}'>
      ${this._renderMenu(_(item).result('menu'))}
    </ul>
</li>\
`);
        } else {
          let copyString;
          let tooltipString;
          if (item.id == null) {
            item.id = uniqueId('item-');
          }
          this.handlers[item.id] = item.click;
          this.closehandlers[item.id] = item.close;
          let liClass = '';
          if (item.disabled != null && _(item).result('disabled')) {
            this.handlers[item.id] = null;
            liClass = 'disabled';
          }
          if (item.active != null && _(item).result('active')) {
            liClass += ' active';
          }
          if (item.tooltip != null) {
            tooltipString = 'data-toggle="tooltip" ';
            tooltipString += `title='${_.escape(item.tooltip)}'`;
          } else {
            tooltipString = '';
          }
          if (item.copy != null) {
            if (!isString(item.copy) && !isFunction(item.copy)) {
              throw new Error(`Unexpected type for \`copy\`: ${typeof item.copy}`);
            }
            copyString = isString(item.copy) ? item.copy : isFunction(item.copy) ? item.copy() : null;
          } else {
            copyString = null;
          }
          // oxlint-disable-next-line no-useless-escape
          const copyAttr = copyString != null ? `data-copy-text=\"${_.escape(copyString)}\"` : '';
          const testAttr = item.dataTestAttrs ? testAttrsAsUnsafeHTML(item.dataTestAttrs) : '';
          const shortcut = item.shortcut ? _.escape(item.shortcut) : '';
          result.push(`\
<li class='${liClass}' ${tooltipString} ${copyAttr} ${testAttr} role='menuitem'>
  <a class='context-item' id='${_.escape(item.id)}'>${_.escape(
    item.name
  )}<span class='faded pull-right'>${shortcut}</span></a>
</li>\
`);
        }
      }
      return result;
    })().join('');
  }

  // @ts-expect-error Property 'render' in type 'ContextMenuView' is not assignable to the same property in base type 'Backdrop'
  render(): ContextMenuView {
    if (this.menu != null) {
      this.$el.html(this._renderMenu(this.menu));
      this.$('[data-toggle="tooltip"]').tooltip({placement: 'right', container: 'body'});
      const contextmenu = this;
      this.$el.find('[data-copy-text]').each(function (this: HTMLElement) {
        clipboard.glue(this, {
          dataTransform() {
            return $(this).attr('data-copy-text');
          },
          // NB: The normal contextmenu close event handling is being interrupted
          // by the copy handlers. This event handler forces the contextmenu to
          // close on a click on the clipboard.glue'd element.
          click() {
            return contextmenu.close();
          },
        });
      });
    }
    return this;
  }
}
ContextMenuView.initClass();

const contextMenu = new ContextMenuView();

if (browser.isBrowser) {
  // If any keys are pressed while the context menu is open,
  // close the context menu.
  // @ts-expect-error Warning: Not all code paths return a value.
  $(window).on('keydown', (event) => {
    if (contextMenu.hasRendered) {
      contextMenu.close();
      return false;
    }
  });
}

const styles = StyleSheet.create({
  submenuAnchor: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ':after': {
      // Hide the CSS border-based caret (we use BenchlingIcon instead)
      display: 'none',
    },
  },
});

export {contextMenu as view};
